import { FC } from 'react';
import { DeletedHarmReportsProps } from './deletedHarmReports.type';
import { DeletedHarmReportsTableHeader } from './deletedHarmReportsTableHeader';
import { DeletedHarmReportsTableFilter } from './deletedHarmReportsTableFilter';
import Table from '../../component/table/table';
import { useDeletedHarmReports } from '../../hooks/useDeletedHarmReports';
import {
  getDeletedHarmReportsTableHeader,
  getDeletedHarmReportsKebabOptions,
} from './deletedHarmReportsHelper';
import { useResponsiveLayout } from '../../hooks/useResponsiveLayout';
import left from '../../assets/left-arrow.png';

export const DeletedHarmReports: FC<DeletedHarmReportsProps> = () => {
  const { isTablet } = useResponsiveLayout();
  const {
    deletedHarmReports,
    loading,
    filters,
    openFilterModal,
    handleOnChangeSearch,
    handleRowClick,
    handleKebabAction,
    toggleFilterModal,
    handleClearFilters,
    handleApplyFilters,
    handleDateApply,
    t,
    handleGoBackClick,
  } = useDeletedHarmReports();

  return (
    <div className="header-content py-4">
      <div className="flex gap-2 font-semibold items-center pb-4">
        <img
          onClick={handleGoBackClick}
          className="aspect-square size-4 cursor-pointer"
          src={left}
          alt="Back"
        />
        <span className="text-xl">{t('harmReports.deletedReports.title')}</span>
      </div>

      <div
        className="table-content pt-6 flex flex-col overflow-hidden"
        style={{ boxShadow: '0px 0px 25px #2F41A51F' }}
      >
        <DeletedHarmReportsTableHeader
          searchQuery={filters.searchQuery}
          handleOnChangeSearch={handleOnChangeSearch}
          selectedDate={filters.selectedDate}
          handleSelectedDate={handleDateApply}
        >
          <DeletedHarmReportsTableFilter
            isOpenFilterModal={openFilterModal}
            handleClearFilters={handleClearFilters}
            handleApplyFilters={handleApplyFilters}
            toggleFilterModal={toggleFilterModal}
          />
        </DeletedHarmReportsTableHeader>
        <div className="flex-grow overflow-y-auto max-h-[700px]">
          <Table
            tableHeader={getDeletedHarmReportsTableHeader(isTablet, t)}
            tableData={deletedHarmReports}
            loading={loading}
            onViewDetail={handleRowClick}
            onKebabSelect={handleKebabAction}
            loadingMenu={{ rowIndex: -1, action: '' }}
            getKebabMenuOptions={getDeletedHarmReportsKebabOptions as any}
          />
        </div>
      </div>
    </div>
  );
};
